<template>
  <div>
    <FileViewer :file-type="fileType" :url="url" style="width:100%;height: 100%"></FileViewer>


  </div>
</template>

<script>
import FileViewer from "./FileViewer";

export default {
  name: "FileViewerWithVersions",
  components: {FileViewer},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      fileType: '',
      url:'',
      fileId: '',
      versionList: [],
      currentVersion: {},
      currentSub: 0,
      odiv: null,
      m3dExts:[".step",".stl",".stp",".obj",".igs",".ifc",".mtl",".3ds",".3dm",".3mf",".glb",".dae",".fbx",".bim"],
      ed3dExts:[".sldprt",".prt"]
    }
  },
  methods: {
    setCurrentVersion() {
      this.currentVersion = this.versionList[this.currentSub] || {};
    },
    calcFileType(suffix) {

      console.log('suffix=' + suffix);
      if(this.m3dExts.includes(suffix)){
        return 'm3d';
      }

      if(this.ed3dExts.includes(suffix)){
        return 'ed3d';
      }

      switch (suffix) {
        case '.pdf':
          return 'pdf';
        case '.png':
        case '.jpg':
        case '.jpeg':
        case '.gif':
        case '.bmp':
          return 'img';
        case '.doc':
        case '.docx':
          return 'word';
        case '.xls':
        case '.xlsx':
          return 'excel';
        case '.ppt':
        case '.pptx':
          return 'ppt';
        case '.mp4':
          return 'mp4';
        case '.dxf':
          return 'dxf';
      }

      return 'others'
    },
    downloadFile(appendix) {
      let url = appendix?.sys_file?.url;
      if (!url) {
        return
      }
      let name = appendix.ver_name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
    prevPage() {
      if (this.currentSub - 1 < 0) {
        this.$message.error("当前已经是最新版本了。")
      } else {
        this.currentSub--
        this.setCurrentVersion();
      }
    },

    nextPage() {
      if (this.currentSub + 1 >= this.versionList.length) {
        this.$message.error("当前已经是最后一个版本了。")
      } else {
        this.currentSub++
        this.setCurrentVersion();
      }
    }
  },
  async created() {

    let suffix = this.parentData.suffix.toLowerCase();
    this.fileType = this.calcFileType(suffix);
    console.log("fileType=" + this.fileType)

    let data = await this.$http('docService.getById', this.parentData)
    console.log("docService.getById.data")
    console.log(data)

    this.versionList = data.ver_list || []
    this.setCurrentVersion();
    this.fileId = this.versionList[0]?.file_id
    this.url = this.versionList[0].sys_file?.url

    console.log("url=" + this.url)
    console.log("fileId=" + this.fileId)

  }
}
</script>

<style scoped>
.titleText {
  font-size: 30px;
  width: 100%;
  text-align: center;
}

img {
  height: 100%;
  width: auto;
  position: relative;
}

.iconArrow {
  width: 60px;
  height: 55px;
  font-size: 30px;
}

.leftButton {
  position: absolute;
  top: 45%;
  left: 2%;
  margin: auto;
}

.rightButton {
  position: absolute;
  top: 45%;
  right: 37%;
  margin: auto;
}

.frame {
  height: calc(100% - 8px);
  width: 100%;
}
</style>
